const useDetermineAmountDisplayStatus = ({
  addOnGift,
  buttonHasBeenClicked,
}) => {
  const { isRequired } = addOnGift;
  if (isRequired) return "text-only";
  if (buttonHasBeenClicked) return "checkbox";
  return "button";
};

export default useDetermineAmountDisplayStatus;
